import React from "react";
import { PropTypes } from "prop-types";
import { HomeDeviceSelect } from "application/home/components";
import { observer } from "mobx-react";
import { mergeCss } from "mrb/common/utils";
import { MrbQuerySearchInput } from "mrb";
import { applicationDefaults } from "common/constants";

function CategoryPageHeaderTemplate({ store, t }) {
    const { deviceSelectStore, anyDevice, rootStore, inSearchMode, categoryGenericSearchViewStore } = store;

    return (
        <div className="c-home__header u-animation--fadeIn">
            <div className="c-home__header__input__wrapper">
                <div className="u-animation--fadeIn">
                    <div className="c-home__header__input">
                        <MrbQuerySearchInput
                            className="c-input c-input--search c-input--search--lrg c-input--base jq-onboarding-search"
                            queryUtility={categoryGenericSearchViewStore.queryUtility}
                            showSearchButton={false}
                            t={t}
                            maxLength={applicationDefaults.maxCharactersLength}
                        />
                    </div>
                </div>

                {anyDevice && !inSearchMode && (
                    <div
                        className={mergeCss(
                            "c-home__header__actions u-width--100",
                            !rootStore.premiumSubscriptionStore.subscriptionExist
                                ? "c-home__header__actions--secondary"
                                : ""
                        )}
                    >
                        <div className="u-display--flex u-display--flex--ai--center u-display--flex--jc--flex-end">
                            <HomeDeviceSelect
                                store={deviceSelectStore}
                                userDeviceStore={rootStore.userDeviceStore}
                                t={t}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

CategoryPageHeaderTemplate.propTypes = {
    store: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default observer(CategoryPageHeaderTemplate);
